import { render } from "./RoleListPage.vue?vue&type=template&id=98ff4b7e&ts=true"
import script from "./RoleListPage.vue?vue&type=script&lang=ts"
export * from "./RoleListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__